import { BaseSecondSidebarPageContent } from "../../shared/components/base/page/BaseSecondSidebarPageContent";
import { IConnectRender } from "../../shared/components/definitions/IConnectRender";
import { FertilizacionMapRender } from "../../shared/components/modulos/fertilizacion/map/FertilizacionMapRender";
import { FertilizacionSecondSidebarRender } from "../../shared/components/modulos/fertilizacion/sidebar/FertilizacionSecondSidebarRender";
import { serviceProvider } from "../../shared/comun/provider/ServiceProvider";
import { APP_RUTA_FINCA } from "../components/ClienteAsideMenuRender";

/** Página del módulo de fertilización: segundo sidebar (análisis por año + alta
 *  de nuevo análisis) + mapa coloreado según el análisis seleccionado. El
 *  disparo del modal de registro de lotes lo maneja el sidebar al seleccionar
 *  un análisis con pendientes (el primero se auto-selecciona al entrar). */
export class FertilizacionPage extends BaseSecondSidebarPageContent {
  /** Mapa vivo de la página (el sidebar le cambia el análisis mostrado). */
  private _mapRender: FertilizacionMapRender | null = null;

  /** El mapa de fertilización (contenido principal). */
  protected getMainRender(): IConnectRender {
    this._mapRender = new FertilizacionMapRender();
    return this._mapRender;
  }

  /** Sidebar de fertilización: volver → mapa de finca; selección → colorea el
   *  mapa con ese análisis. */
  protected getSecondSidebarRender(): IConnectRender {
    return new FertilizacionSecondSidebarRender(
      () => serviceProvider.getLayoutService().navigate(APP_RUTA_FINCA),
      (analisis) => this._mapRender?.setAnalisis(analisis),
    );
  }
}
